import AllPrizesByTier from 'components/prizes/all-prizes-page/AllPrizesByTier';
import FilteredPrizeList, {
  renderGroupingHeader,
} from 'components/prizes/all-prizes-page/FilteredPrizeList';
import { GroupingDropdown } from 'components/prizes/all-prizes-page/GroupingDropdown';
import { useUserStore } from 'hooks/stores/useUserStore';
import { useRouter } from 'next/router';
import { useState } from 'react';

const PrizePage = () => {
  const router = useRouter();
  const tier = router.query.tier;
  const category = router.query?.filter;
  const searchTerm = router.query.term;

  const [categorySecondaryFilter, setCategorySecondaryFilter] = useState<
    string | undefined
  >(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const urlFragment = new URLSearchParams(
      window.location.hash.replace(/^#/g, ''),
    );
    if (tier) {
      return urlFragment.get('category') || undefined;
    }
  });
  const [tierSecondaryFilter, setTierSecondaryFilter] = useState<
    string | undefined
  >(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const urlFragment = new URLSearchParams(
      window.location.hash.replace(/^#/g, ''),
    );
    if (category) {
      return urlFragment.get('tier') || undefined;
    }
    return undefined;
  });

  const userStore = useUserStore();

  // ...if we don't currently have any filters applied, send the user to either all prizes by tier or category
  if (!tier && !category && !searchTerm) {
    return <AllPrizesByTier />;
  }

  const tierForMatches =
    userStore.subscriptionStatusInfo.subscriberStatus || 'PREMIUM';

  const setSecondaryFilter = (newFilterValue: string | undefined) => {
    if (tier) {
      router.replace(newFilterValue ? '#category=' + newFilterValue : '#');
      setCategorySecondaryFilter(newFilterValue);
    } else if (category) {
      router.replace(newFilterValue ? '#tier=' + newFilterValue : '#');
      setTierSecondaryFilter(newFilterValue);
    }
  };

  return (
    <FilteredPrizeList
      showPrizeTierBadges={(Array.isArray(tier) ? tier[0] : tier) == undefined}
      headerComponentColor="white"
      headerComponent={
        <>
          {renderGroupingHeader(
            Array.isArray(category) ? category[0] : category,
            Array.isArray(tier) ? tier[0] : tier,
            tierForMatches,
            false,
          )}
          <div style={{ marginTop: 16 }}>
            <GroupingDropdown
              filterType={
                (Array.isArray(category) ? category[0] : category)
                  ? 'tier'
                  : 'category'
              }
              selectedFilter={tierSecondaryFilter || categorySecondaryFilter}
              setSelectedFilter={setSecondaryFilter}
            />
          </div>
        </>
      }
      category={
        categorySecondaryFilter ||
        (Array.isArray(category) ? category[0] : category)
      }
      tier={tierSecondaryFilter || (Array.isArray(tier) ? tier[0] : tier)}
      term={Array.isArray(searchTerm) ? searchTerm[0] : searchTerm}
    />
  );
};

export default PrizePage;
